import { memo, useEffect } from "react";
import {
  TextInput,
  useDataProvider,
  useEditContext,
  useResourceContext,
} from "react-admin";
import { useFormContext, useWatch } from "react-hook-form";
import { useMutation } from "react-query";

const CodeNumberInput = ({ open, dependOn, disabled, ...props }) => {
  // Kode tetap harus ikut terkirim saat submit, jadi `disabled` hanya diabaikan.
  void disabled;
  const dataProvider = useDataProvider();
  const date = useWatch({ name: dependOn });
  const resource = useResourceContext();
  const { setValue } = useFormContext();
  const { record } = useEditContext();
  // GET NEXT NUMBER
  const { data, mutate, isLoading } = useMutation((dt) =>
    dataProvider.getListNoParams(resource + "/next-number?date=" + dt)
  );
  // GET NEXT NUMBER

  useEffect(() => {
    if (open) {
      if (props.scenario === "edit") {
        if (record && record.date !== date) {
          mutate(date);
        }
      } else {
        mutate(date);
      }
    }
  }, [open, date, record, props.scenario]);
  useEffect(() => {
    if (!isLoading && data !== undefined) {
      setValue(props.source, data);
    }
  }, [data, isLoading, props.source, setValue]);

  return <TextInput {...props} readOnly />;
};

const propsAreEqual = (prevProps, nextProps) => {
  if (
    prevProps.open === nextProps.open &&
    prevProps.source === nextProps.source
  ) {
    // tidak perlu render ulang
    return true;
  }
  // perlu dirender ulang
  return false;
};

export default memo(CodeNumberInput, propsAreEqual);
